"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStorage = exports.SessionStorageKeys = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["CALL_CENTER_WRAPUP_COUNTER"] = "callcenter-wrapup-counter";
})(SessionStorageKeys || (exports.SessionStorageKeys = SessionStorageKeys = {}));
var useSessionStorage = function (key) {
    var _a = React.useState(function () {
        try {
            var item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.error('failed to get item from session storage', error);
            return null;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    var setValue = function (value) {
        try {
            setStoredValue(value);
            window.sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            console.error('failed to set item in session storage', error);
        }
    };
    var cleanup = function () {
        try {
            window.sessionStorage.removeItem(key);
        }
        catch (error) {
            console.error('failed to cleanup item from session storage', error);
        }
    };
    return [storedValue, setValue, cleanup];
};
exports.useSessionStorage = useSessionStorage;
//# sourceMappingURL=index.js.map